import React from "react";
import Carousel from "@components/common/Carousel";
import { TestimonialsDynamicZoneModel } from "@models/strapi-components/testimonials";
import OneTestimonial from "./OneTestimonial";
import VizWrapper from "@components/common/Base/VizWrapper";

export interface TestimonialsProps {
  componentData: TestimonialsDynamicZoneModel;
}
const Testimonials: React.FunctionComponent<TestimonialsProps> = ({
  componentData,
}) => {
  const { testimonials } = componentData;
  return (
    <VizWrapper className="md:px-12 xl:px-[160px]">
      <Carousel
        data={testimonials}
        render={OneTestimonial}
        btnClassName="bg-dark-purple-50 !h-8 !w-8 opacity-50 md:opacity-100"
      />
    </VizWrapper>
  );
};

export default Testimonials;
